<template>
  <b-modal
    ref="modal-comment"
    id="modal-comment"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="px-3 py-5 text-center">
      <img src="@/assets/icon-comment.png" alt="" width="120" height="120">
      <h4 class="text-bold mt-4">Input Your Comment</h4>
      <b-form-textarea
        rows="3"
        v-model.trim="comment"
        placeholder="Enter your comment"
        name="comment"
        no-resize
        class="text-muted mt-4 mb-5 w-75 mx-auto"
        :state="action === 'approve' || comment ? null : false"
      />
      <div class="d-flex justify-content-around align-items-center mt-5">
      <b-button class="btn-custom px-5" variant="info" @click="confirm()">
        Submit
      </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    action: {
      types: String,
      default: () => 'nice'
    }
  },

  data: () => ({
    comment: ''
  }),

  methods: {
    confirm() {
      if (this.action === 'revise' && this.comment === '') {
        return false
      } else {
        this.$bvModal.hide('modal-comment')
        this.$emit('submit', this.comment)
        this.comment = ''
      }
    }
  }
}
</script>
